import PrintDialog from './PrintDialog';

export default PrintDialog;



// WEBPACK FOOTER //
// ./src/components/Building/PrintDialog/index.js